import React from "react";
import { Table } from "@heroui/react";

interface SkeletonRowProps {
  /** Number of data columns (excluding the checkbox column when withCheckbox is true) */
  colCount: number;
  /** How many columns from the left get a wide skeleton (default: 2) */
  wideCount?: number;
  /** Render leading checkbox skeleton cell (default: true) */
  withCheckbox?: boolean;
}

const SkeletonRow: React.FC<SkeletonRowProps> = ({
  colCount,
  wideCount = 2,
  withCheckbox = true,
}) => {
  return (
    <Table.Row className="sc-table__row sc-table__row--skeleton">
      {withCheckbox && (
        <Table.Cell
          className="sc-table__td sc-table__td_checkbox sc-table__td_sticky-left"
          style={{ left: 0 }}
        >
          <div className="sc-skeleton sc-skeleton--checkbox" />
        </Table.Cell>
      )}
      {Array.from({ length: colCount }, (_, i) => (
        <Table.Cell key={i} className="sc-table__td">
          <div
            className={[
              "sc-skeleton",
              i < wideCount ? "sc-skeleton--wide" : "sc-skeleton--narrow",
            ].join(" ")}
          />
        </Table.Cell>
      ))}
    </Table.Row>
  );
};

SkeletonRow.displayName = "SkeletonRow";
export default SkeletonRow;
